import { newTreeNodeList } from "../TreeNodeMakers";
/**
 * TreeNodeListCopies class
 */
export class TreeNodeListCopies {
    parentTreeNodeList;
    /**
     * Creates an instance of TreeNodeListCopies.
     *
     * @param  {TreeNodeList} parentTreeNodeList  The parent TreeNodeList.
     */
    constructor(parentTreeNodeList) {
        this.parentTreeNodeList = parentTreeNodeList;
    }
    /**
     * Returns a shallow copy of the parent TreeNodeList.
     *
     * @returns {TreeNodeList}  The shallow copy.
     */
    get shallow() {
        return newTreeNodeList(this.parentTreeNodeList.nodes);
    }
    /**
     * Returns a deep copy of the parent TreeNodeList. Not currently
     * implemented. Warn the user to use treeNodeListDeepClone instead.
     */
    get deep() {
        throw "Can't call this deepClone function. Use treeNodeListDeepClone in Deserializers.ts instead.";
    }
}
